document.addEventListener('DOMContentLoaded', () => {
  const sizeGuideSection = document.querySelector('size-guide-section');
  const sizeGuideTrigger = document.querySelector('size-guide-section a');
  const sizeGuideModel = document.querySelector('#pdp-size-guide');
  const sizeGuideModelOverlay = document.querySelector('#pdp-size-guide .pdp-size-guide__overlay');
  const sizeGuideModelClose = document.querySelector('#pdp-size-guide .pdp-size-guide__close');
  const tabs = document.querySelectorAll('.pdp-size-guide__modal__toggle');

  if(tabs.length < 1){
    sizeGuideSection.setAttribute('hidden','');
  }

  if(sizeGuideTrigger && sizeGuideModel){
    sizeGuideTrigger.addEventListener('click',(e) => {
      e.preventDefault();
      if(sizeGuideModel){
        sizeGuideModel.classList.add('model-active');
        sizeGuideModel.removeAttribute('hidden');
        document.body.style.overflow = 'hidden';
      }
    });
    // close modal on close icon click
    sizeGuideModelClose.addEventListener('click',(e) => {
      e.preventDefault();
      if(sizeGuideModel){
        sizeGuideModel.classList.remove('model-active');
        sizeGuideModel.setAttribute('hidden','');
        document.body.style.overflow = '';
      }
    });
    // close modal on overlay click
    sizeGuideModelOverlay.addEventListener('click',(e) => {
      e.preventDefault();
      if(sizeGuideModel){
        sizeGuideModel.classList.remove('model-active');
        sizeGuideModel.setAttribute('hidden','');
        document.body.style.overflow = '';
      }
    });

    // tab toggle
    tabs.forEach(tab => {
      tab.addEventListener('click',(e) => {
        e.preventDefault();
        tabs.forEach(tb => tb.hasAttribute('aria-selected') ? tb.setAttribute('aria-selected','false') : null);
        const id = e.target.id;
        const contents = document.querySelectorAll('.pdp-size-guide__modal__tab-inner-content');
        setTimeout(() => {
          contents.forEach(content => {
            if(content.getAttribute('aria-labelledby') === id){
              content.hasAttribute('hidden') ? content.removeAttribute('hidden') : null;
              e.target.setAttribute('aria-selected','true');
            }else{
              content.hasAttribute('hidden') ? null : content.setAttribute('hidden','true');
            }
          })
        },10);
      });
    });

  }
});